import HtmlHelper from '../utils/html-helper';
import HttpHelper from '../utils/http-helper';
import UrlParameterParser from "../utils/url-parameter-parser";

export default class CountriesModule {

	constructor(cookie, isLimited) {
		this.selCountries = cookie;
		this.filteredCountriesMenu = document.querySelector('#filteredCountriesMenu');
		this.filteredCountriesList = document.querySelector('#filteredCountriesList');
		this.countriesSelectedList = document.querySelector('#countriesSelectedList');
		this.searchCountriesInput = document.querySelector('#searchCountriesInput');
		this.searchCountriesInputResetButton = document.querySelector('#searchCountriesInputResetButton');

		this.countries = [];
		this.countriesSelected = new Set();
        this.lastCountryNameSelected = null;
		this.countriesSelectedListisLimited = isLimited;

		this.primaryModule = null;
		this.secondaryModules = [];
	}

	initialiseModules(primaryModule, secondaryModules) {
        this._parseParameterCountryCode();
		this.setPrimaryModule(primaryModule);
		if (secondaryModules) {
			secondaryModules.forEach(module => {
				this.secondaryModules.push(module);
			});
		}
		this.addEventListeners();
	}

    _parseParameterCountryCode() {
        const parameterCountryCode = UrlParameterParser.getParsedParameterValue('land');
        const parameterCountry = this.countries.find((country) => country?.isoCode?.toLowerCase() === parameterCountryCode?.value?.toLowerCase());
        if (parameterCountry?._id) {
            this.selCountries.clearCountries();
            this.selCountries.addCountry(parameterCountry);
        }
        UrlParameterParser.deleteUrlParameter('land');
    }

	setPrimaryModule(primaryModule) {
		this.primaryModule = primaryModule;
	}
	setSecondaryModules(secondaryModules) {
		if (secondaryModules) {
			secondaryModules.forEach(module => {
				this.secondaryModules.push(module);
			});
		}
	}

	addEventListeners() {
		this.searchCountriesInputResetButton.addEventListener('click', () => {
			this.countriesSelected.clear();
            this.lastCountryNameSelected = null;
			if(this.selCountries) {
				this.selCountries.clearCountries();
			}
			this.primaryModule.dataTable?.resetDataTable();
			this.resetSearchCountriesInput();
			if (this.secondaryModules) {
				this.secondaryModules.forEach(module => {
					module.resetSelect();
					module.select?.setAttribute('disabled', 'true');
					module.resetButton?.setAttribute('disabled', 'true');
				});
			}
			this.countriesSelectedList.innerHTML = null;
			this.searchCountriesInputResetButton.setAttribute('disabled', 'true');
			this.searchCountriesInput.removeAttribute('disabled');
			this.searchCountriesInput.setAttribute('placeholder', 'Bitte wählen');
		});
		this.searchCountriesInput.addEventListener('input', () => {
			this.filterCountries(this.searchCountriesInput.value);
			if (!this.searchCountriesInput.value) {
				this.searchCountriesInputResetButton.setAttribute('disabled', 'true');
			} else {
				this.searchCountriesInputResetButton.removeAttribute('disabled');
			}
		});
		this.searchCountriesInput.addEventListener('focusin', () => {
			this.filteredCountriesMenu.setAttribute('aria-hidden', 'false');
			this.searchCountriesInput.setAttribute('aria-expanded', 'true');
			this.filteredCountriesMenu.focus();
		});
		this.filteredCountriesMenu.querySelectorAll('ul').forEach(element => {
			element.addEventListener('mouseover', (event) => {
				this.filteredCountriesMenu.focus();
			});
		});
		this.filteredCountriesMenu.addEventListener('focusout', (event) => {
			if (!event.currentTarget.contains(event.relatedTarget)) {
				this.filteredCountriesMenu.setAttribute('aria-hidden', 'true');
				this.searchCountriesInput.setAttribute('aria-expanded', 'false');
			}
		});
		this.filteredCountriesMenu.addEventListener('keydown', (event) => {
			if(event.key === 'Escape'){
				this.filteredCountriesMenu.setAttribute('aria-hidden', 'true');
				this.searchCountriesInput.setAttribute('aria-expanded', 'false');
			}
		});
		this.searchCountriesInputResetButton.addEventListener('click', () => {
			this.resetSearchCountriesInput();
			this.primaryModule.dataTable?.resetDataTable();
			this.searchCountriesInputResetButton.setAttribute('disabled', 'true');
		});

		document.addEventListener('click', function (event) {
		    const toggles = document.querySelectorAll('.p-contextual-menu__toggle');
			for (var i = 0, l = toggles.length; i < l; i++) {
				const filteredCountriesMenu = document.querySelector('#filteredCountriesMenu');
				const searchCountriesInput = document.querySelector('#searchCountriesInput');

				var toggle = toggles[i];
				var clickOutside = !(toggle.contains(event.target) || filteredCountriesMenu.contains(event.target));

				if (clickOutside) {
					filteredCountriesMenu.setAttribute('aria-hidden', 'true');
					searchCountriesInput.setAttribute('aria-expanded', 'false');
				}
			}
		});
	}

	async getBvCountries (){
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/countryBv?sort={"nameShort": 1}`);
		this.countries = response?.data;
	}

	static async getBvCountryByName(countryName) {
		const countryIds = [];
		await HttpHelper.fetchData(`${location.origin}/api/public/countryBv?filter={"nameShort": "${countryName}"}`).then(element => {
			element.data.forEach(country => {
				if (country.hasOwnProperty('_id')) {
					countryIds.push(country._id);
				}
			});
		});
		return countryIds;
	}

	async getCountries (){
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/country?sort={"nameShort": 1}`);
		this.countries = response?.data;
	}

	static async getCountryByName(countryName) {
		const countryIds = [];
		await HttpHelper.fetchData(`${location.origin}/api/public/country?filter={"nameShort": "${countryName}"}`).then(element => {
			element.data.forEach(country => {
				if (country.hasOwnProperty('_id')) {
					countryIds.push(country._id);
				}
			});
		});
		return countryIds;
	}

	renderCountryOption(_filteredCountries) {
	    const filteredCountries = _filteredCountries.filter(country => !this.countriesSelected.has(country._id))
		if(Array.isArray(filteredCountries)) {
			filteredCountries.forEach(country => {
				const menuItem = HtmlHelper.createElementFromHTML(`
                <li>
                    <a href="#" class="p-contextual-menu__link">${country.nameShort}</a>
                </li>
            `);
				menuItem.querySelector('a').addEventListener('click', (event) => {
					this.selectCountry(event, country);
					if(!!this.countriesSelectedListisLimited) {
                        this.filteredCountriesMenu.setAttribute('aria-hidden', 'true');
                    }
				});
				this.filteredCountriesList.appendChild(menuItem);
			});
		}
	}

	resetSearchCountriesInput () {
		this.searchCountriesInputResetButton.setAttribute('disabled', 'true');
		this.searchCountriesInput.value = '';
		this.filterCountries('');
	}

	filterCountries (filterValue) {
		this.filteredCountriesList.innerHTML = null;

		const filteredCountries = this.countries
            .filter(country => !this.countriesSelected.has(country._id))
            .filter(country => {
			return country.nameShort.toLowerCase().includes(filterValue.toLowerCase());
		});
		this.renderCountryOption(filteredCountries);
	}

	selectCountry (event, country) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!!event) {
            event?.target?.parentNode?.remove()
            this.searchCountriesInput.focus()
        }
        const countryId = country._id
        this.lastCountryNameSelected = country.nameShort
		if (!this.countriesSelected.has(countryId)) {
			if (this.countriesSelected.size > 0 &&
                !this.countriesSelected.size === 0 &&
                countryId === 'allCountries') {

				this.countriesSelectedList.innerHTML = null;
				this.countriesSelected.clear();
                this.lastCountryNameSelected = null;
				if (this.secondaryModules) {
					this.secondaryModules.forEach(module => {
						module.selected = null;
					});
				}
            }
            const comment = country.comment ? `
                <span class="p-tooltip" aria-describedby="${countryId}-comment">
                  <i style="margin-right: 4px" class="p-icon--information"></i>
                  <span class="p-tooltip__message" style="max-width: 400px; min-width: 300px; white-space: break-spaces;" role="tooltip" id="${countryId}-comment">${country.comment}</span>
                </span>
                ` : ''
			const chip = HtmlHelper.createElementFromHTML(`
             <div class="p-chip" id="${countryId}">
                       ${comment}        
                    <span class="p-chip__value">${this.lastCountryNameSelected}</span>
                    <button class="p-chip__dismiss">
                        <i class="p-icon--close">Dismiss</i>
                    </button>
                    
             </div>`);

			chip.querySelector('button').addEventListener('click', () => {
				this.dismissCountry(chip, country);
			});
			if(this.countriesSelectedListisLimited) {
				if(this.countriesSelected.size === 0) {
					this.countriesSelectedList.appendChild(chip);
					this.countriesSelected.add(countryId);
					if(this.selCountries) {
						this.selCountries.addCountry(country);
					}
					this.searchCountriesInput.setAttribute('disabled', 'true');
					this.searchCountriesInput.setAttribute('placeholder', 'Keine weitere Auswahl möglich. Bitte löschen Sie zunächst das ausgewählte Land!');
				}
			}
			if(!this.countriesSelectedListisLimited){
				this.countriesSelectedList.appendChild(chip);
				this.countriesSelected.add(countryId);
				if(this.selCountries) {
					this.selCountries.addCountry(country);
				}
			}
			this.searchCountriesInputResetButton.removeAttribute('disabled');

			if (event) {
				this.primaryModule.loadOptions();
				if (this.primaryModule.dataTable) this.primaryModule.dataTable.page = 1;
				if (this.primaryModule.dataTable) this.primaryModule.dataTable.offset = 0;
				this.primaryModule.getData().then();
			}
		}
        this.searchCountriesInput.value = '';
        this.filterCountries('')
    }

	dismissCountry (el, country) {
		el.remove();
		this.countriesSelected.delete(country._id);
		if(this.selCountries) {
			this.selCountries.removeCountry(country);
		}
		if (this.primaryModule.dataTable) this.primaryModule.dataTable.page = 1;
		if (this.primaryModule.dataTable) this.primaryModule.dataTable.offset = 0;
		if (this.countriesSelected.size === 0) {
			this.searchCountriesInputResetButton.dispatchEvent(new Event('click'));
		} else {
			this.primaryModule.loadOptions();
			this.primaryModule.getData().then();
		}
		this.filterCountries('')
	}
}

